import React from 'react';
import SuccessIcon from 'react-icons/lib/md/check-circle';

import {
    CardBlock
} from 'reactstrap';
const PageSuccessMessage = ({successMessage}) => (
    <div>
        <CardBlock className="table-responsive">
            <div className="row">
                <h6 className="mb-4 col-md-8 text-uppercase pull-left">&nbsp;</h6>

            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="text-center">
                        <SuccessIcon size="70" color="rgba(84, 175, 79, 1)"/>

                    </div>
                    <p className="text-center">
                        {successMessage}
                    </p>
                </div>
            </div>
        </CardBlock>
    </div>
);

export default PageSuccessMessage;


// WEBPACK FOOTER //
// ./src/views/utils/pageSuccess.js